import { Link } from "react-router-dom";
import React from "react";
import "../styles/AIDesign.css";

const AIDesign = () => {
  return (
    <main className="ai-design-page">

      <section className="aid-hero">
        <div><span>INTELLIGENT PRODUCT EXPERIENCES</span>
        <h1>Make AI feel useful, clear and human</h1>
        <p>
          We design AI-powered features around real user needs, pairing the capability of intelligent systems with experiences people can understand and trust.
        </p>
        <Link to="/contact">Explore an AI product idea <b aria-hidden="true">↗</b></Link></div>
        <div className="aid-visual" aria-hidden="true"><div className="aid-orbit aid-orbit-one"/><div className="aid-orbit aid-orbit-two"/><div className="aid-core">AI<span>WITH PURPOSE</span></div><i className="aid-node aid-node-one">ASK</i><i className="aid-node aid-node-two">LEARN</i><i className="aid-node aid-node-three">ACT</i></div>
      </section>

      <section className="aid-capabilities">
        <div className="aid-heading"><span>DESIGNED AROUND PEOPLE</span><h2>Intelligence is only useful when the experience makes sense</h2><p>We make the system’s capabilities, limits and next steps clear throughout the journey.</p></div>

        <div className="aid-grid">
          <article><span>01</span><h3>AI interaction design</h3><p>Shape prompts, responses and handoffs into intuitive conversations and workflows.</p></article>
          <article><span>02</span><h3>Intelligent workflows</h3><p>Find the right moments to assist, automate or recommend while keeping users in control.</p></article>
          <article><span>03</span><h3>Trust and transparency</h3><p>Set clear expectations with helpful explanations, feedback and graceful recovery paths.</p></article>
          <article><span>04</span><h3>Prototypes and validation</h3><p>Explore concepts with realistic prototypes, test assumptions and refine before build.</p></article>
        </div>
      </section>

      <section className="aid-principles"><span>OUR DESIGN LENS</span><p>Useful by default <i>·</i> Clear about uncertainty <i>·</i> Human in control <i>·</i> Ready to improve</p></section>
      <section className="aid-bottom">
        <h2>Have an AI feature to shape?</h2><p>Let’s turn the technical possibility into an experience your customers can use with confidence.</p>
        <Link to="/contact">Talk with our design team <b aria-hidden="true">↗</b></Link>
      </section>

    </main>
  );
};

export default AIDesign;